import React, { useRef } from "react";
// import Navbar from "./Navbar";
import Footer from "./Footer";
import FaqSection from "./FAQ";
import { Link } from "react-router-dom";
import blueTick from "../../images/LandingPageImage/blueTick.svg";
import usePlans from "../../services/LandingPage/usePlans";
import Navbar from "./Navbar";

const PricingPage = () => {
  const pricingRef = useRef(null);
  const { plans, loading } = usePlans("IN");

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        Loading plans...
      </div>
    );
  }

  return (
    <>
      <Navbar />

      {/* Top 3 Cards */}
      <section className="py-16 bg-green-50">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-12 text-green-900">
            Choose the Perfect Plan for Your Growth
          </h2>

          <div className="grid md:grid-cols-3 gap-8">
            {plans.slice(0, 3).map((plan, index) => (
              <div
                key={plan.id}
                className={`rounded-2xl shadow-lg p-8 bg-white ${
                  index === 1 ? "border-2 border-green-600" : ""
                }`}
              >
                <h4 className="text-xl font-semibold mb-4 text-start">
                  {plan.plan_name}
                  {index === 1 && (
                    <span className="ml-2 text-sm bg-green-600 text-white px-2 rounded-full">
                      Most Popular
                    </span>
                  )}
                </h4>

                <div className="text-3xl font-bold text-green-600 mb-3 text-start">
                  ₹{Number(plan.plan_price).toFixed(0)}
                  <span className="text-base text-gray-500"> /mo</span>
                </div>

                <p className="note text-start">No credit card required!</p>
                <p className="text-gray-600 mb-4 text-start">
                  {plan.plan_desc}
                </p>

                <Link
                  to={`/buy-plan/${plan.id}`}
                  className="block mt-4 bg-green-500 hover:bg-green-600 text-white py-3 rounded-xl transition"
                >
                  Buy Now →
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Full Pricing Section */}
      <section className="py-20 bg-white" ref={pricingRef}>
        <div className="max-w-6xl mx-auto px-4 text-center">
          <h1 className="text-3xl font-bold mb-6 text-green-800 max-w-5xl">
            Unlock the Best WhatsApp Business API Pricing with Super Affordable
            Plans & Premium Services!
          </h1>

          <div className="flex flex-col md:flex-row justify-center gap-6 mb-12 text-gray-600">
            {[
              "15-days free trial",
              "Cancel anytime",
              "No credit card required",
            ].map((item, index) => (
              <div key={index} className="flex items-center gap-2">
                <img src={blueTick} width={14} alt="" />
                {item}
              </div>
            ))}
          </div>

          <div className="grid md:grid-cols-3 gap-10">
            {plans.map((plan) => (
              <div
                key={plan.id}
                className={`rounded-2xl shadow-lg p-8 ${
                  plan.plan_name === "Standard"
                    ? "border-2 border-green-600"
                    : "border"
                }`}
              >
                <h3 className="text-xl font-semibold mb-4 text-start">
                  {plan.plan_name}
                </h3>

                <div className="text-3xl font-bold text-green-600 mb-2 text-start">
                  {plan.currency === "INR" ? "₹" : "$"}
                  {Number(plan.plan_price).toFixed(0)}
                  <span className="text-base text-gray-500 ml-1">
                    {plan.plan_duration}
                  </span>
                </div>

                {plan.is_setup_fee_applicable === "Y" && (
                  <div className="border-t border-b border-gray-200 py-3 my-4">
                    <p className="text-sm text-gray-900">
                      + OneTime Setup Fee {plan.currency === "INR" ? "₹" : "$"}
                      {Number(plan.setup_fee).toFixed(0)}
                    </p>
                  </div>
                )}

                <p className="text-gray-600 mb-6 text-start">
                  {plan.plan_desc}
                </p>

                <Link
                  to={`/buy-plan/${plan.id}`}
                  className="block text-center bg-green-600 hover:bg-green-700 text-white py-3 rounded-xl transition mb-6"
                >
                  {plan.button_text || "Start Free Trial"} →
                </Link>

                <div className="space-y-3 text-left">
                  {plan.features
                    ?.filter((f) => f.status === "Y")
                    .map((feature, index) => (
                      <div key={index} className="flex items-start gap-2">
                        <img src={blueTick} className="w-4 mt-1" alt="" />
                        <span className="text-sm text-gray-700">
                          {feature.feature_name}
                        </span>
                      </div>
                    ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <FaqSection />
      <Footer />
    </>
  );
};

export default PricingPage;
